import {onFind, initInScope} from "@elements/init-modules-in-scope";
import {findAllIn, findIn, on} from "@elements/dom-utils";
import axios from "axios";
import * as formValidation from "@elements/form-validation";

export function init() {
    onFind('.js-append-business-application', function (form) {
        let select = findIn('.js-append-business-application__select', form);
        let targetDiv = findIn('.js-append-business-application__target', document);
        let formInstance;
            on('change', () =>{
                let selectedOption = select.options[select.selectedIndex];
                let url = selectedOption.getAttribute('data-url');
                // console.log(url);

                if (url) {
                    let pendingRequest = axios({method: "GET", url: url});

                    pendingRequest.then((response) => {
                        if(response.data.success) {
                            targetDiv.innerHTML = response.data.html;
                            formValidation.getApi(form).then((formApi) => {

                                formInstance = formApi.getFormInstance();
                                console.log('formInstance',formInstance );
                                findAllIn('.js-form-validation__group select', targetDiv).forEach((input) => {
                                    console.log(targetDiv, input);
                                    formInstance.addField(input.getAttribute('name'));
                                });

                            });
                                initInScope(targetDiv);
                            console.log('targetDiv', targetDiv );


                        }
                    }).catch((error) => {
                        console.error(error);
                    });
                } else {
                    console.log('No URL found');
                }
            }, select);
        });
}